var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInterview = function SvgInterview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.143 30.37c.67.13 1.347.198 2.03.205 1.719 0 3.418-.363 4.987-1.067l5.158.759a1.716 1.716 0 0 0 1.72-1.892l-.62-5.21a12.002 12.002 0 0 0 .998-4.834A12.173 12.173 0 0 0 23.19 6.191a12.158 12.158 0 0 0-11.849 9.424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB3A90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.173 24.575a9.434 9.434 0 0 1-2.03 5.795 9.35 9.35 0 0 1-7.292 3.438 9.501 9.501 0 0 1-3.816-.825l-3.852.689a1.257 1.257 0 0 1-1.377-1.462l.534-3.938a9.167 9.167 0 0 1-.757-3.699 9.3 9.3 0 0 1 6.758-8.956 8.668 8.668 0 0 1 2.529-.362 9.317 9.317 0 0 1 9.303 9.322"
  })));
};
export default SvgInterview;